var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"t-page-lk t-page-lk-wrapper"},[_c('transition',{attrs:{"name":"page"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/templates/pages/lk/index.vue?vue&type=template&id=25ad11e6&
// module id = 1316
// module chunks = 0